import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/articles';

export default function FeaturedSection() {
  const mainArticle = featuredArticles[0];
  const sideArticles = featuredArticles.slice(1, 3);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            🔥 热点<span className="text-accent-500">大瓜</span>专区
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            全网最热的爆料都在这里，别错过任何一个精彩大瓜
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-4 md:gap-5">
          {mainArticle && (
            <Link
              to={`/article/${mainArticle.slug}`}
              className="relative lg:w-1/2 rounded-lg overflow-hidden group cursor-pointer h-[320px] md:h-[420px]"
            >
              <img
                src={mainArticle.image}
                alt={mainArticle.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-3 py-1 bg-primary-500 text-background-50 text-xs rounded-full mb-3">
                  {mainArticle.categoryName}
                </span>
                <h3 className="font-heading text-lg md:text-2xl font-bold text-background-50 mb-2 line-clamp-2">
                  {mainArticle.title}
                </h3>
                <p className="text-background-50/60 text-sm line-clamp-2 mb-3">
                  {mainArticle.excerpt}
                </p>
                <div className="flex items-center gap-3 text-background-50/50 text-xs">
                  <span><i className="ri-eye-line mr-1"></i>{(mainArticle.views / 10000).toFixed(1)}万</span>
                  <span><i className="ri-chat-3-line mr-1"></i>{mainArticle.comments}</span>
                  <span>{mainArticle.date}</span>
                </div>
              </div>
            </Link>
          )}

          <div className="lg:w-1/2 flex flex-col sm:flex-row lg:flex-col gap-4 md:gap-5">
            {sideArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="flex-1 relative rounded-lg overflow-hidden group cursor-pointer h-[200px] md:h-auto"
              >
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <span className="inline-block px-2.5 py-0.5 bg-accent-500 text-background-50 text-xs rounded-full mb-2">
                    {article.categoryName}
                  </span>
                  <h3 className="font-heading text-base md:text-lg font-bold text-background-50 mb-1 line-clamp-2">
                    {article.title}
                  </h3>
                  <div className="flex items-center gap-3 text-background-50/50 text-xs">
                    <span><i className="ri-eye-line mr-1"></i>{(article.views / 10000).toFixed(1)}万</span>
                    <span>{article.date}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}